export const route = {
    params: {
        id: 'id',
    },
    patterns: {
        createNewLearningOpportunity: '/learning-opportunities/new',
        learningOpportunities: '/learning-opportunities',
        learningOpportunityDetails: '/learning-opportunities/:id',
        learningOpportunityEdit: '/learning-opportunities/:id/edit',
    },
    searchParams: {
        filtration: {
            skillFilter: 'skillFilter',
            workspaceFilter: 'workspaceFilter',
        },
        navigation: {
            courses: 'courses',
        },
        searchTerm: 'search',
        state: 'state',
        tab: 'tab',
    },
} as const;

export const learningOpportunityEditPageUrl = (learningOpportunityId: string): string =>
    route.patterns.learningOpportunityEdit.replace(':id', learningOpportunityId);
